import React, { useEffect, useState } from 'react';
import { useTranslation } from '../../contexts/translation';
import { Columns } from '../../pages/WorkActivities/Columns';
import { WorkActivityGroupsFilterData } from '../../pages/WorkActivityGroups/WorkActivityGroups';
import { WorkActivityGroup } from '../../types/workActivityGroup.types';
import WorkActivityModal from '../modals/WorkActivityModal';
import { SisDataGrid } from '../table';
import { IDataGrid } from './AssetsDataGrid';

interface Props extends IDataGrid {
  userCanCreate?: boolean;
  defaultFilterData?: WorkActivityGroupsFilterData;
  onFilterChanged?: (WorkActivityGroupsFilterData) => void;
  isDateFilter?: boolean;
  mutateData?: () => void;
  storageKey: string;
  modalVisibility: boolean;
  selectedData: any;
  selectedAction: any;
  workActivityGroups?: Array<WorkActivityGroup>;
  onDataSubmit: (data: any, actionType: any) => void;
  handleModalVisibility: () => void;
}

export const WorkActivityDataGrid = ({
  data,
  handleEdit,
  defaultFilterData,
  onToolbarPreparing,
  isDateFilter,
  modalVisibility,
  selectedData,
  selectedAction,
  workActivityGroups,
  onDataSubmit,
  handleModalVisibility,
}: Props) => {
  const { translate } = useTranslation();
  const transFormName = 'WorkActivity.List';
  // TODO: předělat na work activity
  const [filterData, setFilterData] = useState<WorkActivityGroupsFilterData | undefined>(
    isDateFilter ? defaultFilterData : undefined,
  );

  useEffect(() => {
    setFilterData(isDateFilter ? defaultFilterData : undefined);
  }, [defaultFilterData]);

  const columns = Columns(handleEdit, translate);

  return (
    <>
      <SisDataGrid
        data={data}
        keyExpr={'id'}
        transFormName={transFormName}
        columns={columns}
        onToolbarPreparing={onToolbarPreparing}
        exportName="work-activity"
        enableXlsxExport
        columnChooser
        allowColumnResizing
        allowColumnReordering
        allowHeaderFiltering
        onCellDblClick={(e) => handleEdit && handleEdit(e)}
        pageSizeChangeVisible
      />
      {modalVisibility && (
        <WorkActivityModal
          isVisible={modalVisibility}
          workActivityGroups={workActivityGroups ?? []}
          data={selectedData ?? null}
          actionType={selectedAction}
          onSubmit={onDataSubmit}
          onClose={handleModalVisibility}
        />
      )}
    </>
  );
};
